export default "__VITE_ASSET__f6131a73__"